import { addressService, CityMultiLingualDTO } from "@lg-cfa/services";
import { useEffect, useState } from "react";

import { useDebouncedEffect } from "../useDebouncedEffect";
import { useFlowNavigation } from "../useFlowNavigation";

import { PageNames } from "@enums";

export function useB2BCities(
    typeAheadCity: string,
    propertyCity?: CityMultiLingualDTO,
) {
    const isSSR = typeof window === "undefined";
    const [B2BCities, setB2BCities] = useState<Array<CityMultiLingualDTO>>([]);
    const [citiesLoading, setCitiesLoading] = useState<boolean>(false);
    const { navigateTo } = useFlowNavigation();

    const getCitiesFromData = (searchString: string) => {
        setCitiesLoading(true);
        addressService
            .getAllCities(searchString)
            .then((r) => {
                setB2BCities(r);
            })
            .catch((error) => {
                console.error(error);
                navigateTo(PageNames.TechnicalDifficulties);
            })
            .finally(() => {
                setCitiesLoading(false);
            });
    };

    useEffect(() => {
        if (
            B2BCities.length > 0 ||
            (typeAheadCity === "" && B2BCities.length === 0)
        ) {
            setCitiesLoading(false);
        }
    }, [B2BCities, typeAheadCity]);

    useDebouncedEffect(
        () => {
            if (!isSSR && typeAheadCity.length > 1) {
                getCitiesFromData(typeAheadCity);
            } else if (
                !isSSR &&
                propertyCity &&
                propertyCity &&
                propertyCity.postalCode &&
                typeAheadCity.length === 0
            ) {
                getCitiesFromData(propertyCity.postalCode);
            } else if (typeAheadCity === "") {
                setB2BCities([]);
            }
            // eslint-disable-next-line
        },
        300,
        [isSSR, typeAheadCity, propertyCity],
    );

    return { B2BCities, citiesLoading };
}
